import React from 'react';
import { transformSuggestedFilters } from 'site-modules/shared/utils/inventory/semantic-search';
import { transformFacetsToUrlParams } from 'site-modules/shared/utils/inventory/srp-llm-suggested-facets';
import { useSearchResults } from 'site-modules/personalized-search/hooks/use-search-results';

export function withInitialFilters(WrappedComponent) {
  function Component(props) {
    const { pageStruct } = useSearchResults();
    const inventoryComponentParams = pageStruct?.inventory;
    const modifiedRadius = inventoryComponentParams?.modifiedFacets?.radius;
    const initialFilters = transformFacetsToUrlParams(
      transformSuggestedFilters(inventoryComponentParams)?.filters,
      modifiedRadius
    );

    return <WrappedComponent initialFilters={initialFilters} {...props} />;
  }

  Component.displayName = `withInitialFilters(${WrappedComponent.displayName || WrappedComponent.name})`;

  return Component;
}
